// Sanitize user input for phone fields:
//  - Allow only digits, spaces, "+", "-", "(", ")" as visible chars
//  - Cap the number of DIGITS at 15 (E.164 international max)
// This is a soft client-side guard — the server validates strict format
// (Italian +39 → 12 digits, mobile only) in is_valid_phone().
export const PHONE_MAX_DIGITS = 15;

export function sanitizePhoneInput(raw) {
  if (!raw) return "";
  // Keep only allowed visible chars
  const cleaned = raw.replace(/[^\d+\-()\s]/g, "");
  // Walk the string and stop once we exceed PHONE_MAX_DIGITS
  let digitCount = 0;
  let out = "";
  for (const ch of cleaned) {
    if (/\d/.test(ch)) {
      if (digitCount >= PHONE_MAX_DIGITS) break;
      digitCount++;
    }
    out += ch;
  }
  return out;
}
